import { Users, MessageCircle, Calendar, Sparkles } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export const DemoHerds = () => {
  return (
    <Card className="overflow-hidden bg-card/95 backdrop-blur-sm border-border/50">
      <div className="p-4 space-y-4">
        {/* Herd Header */}
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/30 to-primary/10 flex items-center justify-center">
            <span className="text-2xl">🧘‍♀️</span>
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-foreground">Morning Yogis</h3>
            <p className="text-xs text-muted-foreground">Movement enthusiasts</p>
          </div>
          <Badge variant="secondary" className="text-xs">
            <Users className="w-3 h-3 mr-1" />
            24 members
          </Badge>
        </div>
        
        {/* Member Avatars */}
        <div className="flex items-center gap-2">
          <div className="flex -space-x-2">
            {['S', 'M', 'J', 'A'].map((initial, i) => (
              <Avatar key={i} className="w-8 h-8 border-2 border-background">
                <AvatarFallback className="bg-primary/20 text-primary text-xs">
                  {initial}
                </AvatarFallback>
              </Avatar>
            ))}
          </div>
          <span className="text-xs text-muted-foreground">+20 more</span>
        </div>
        
        {/* Features */}
        <div className="grid grid-cols-2 gap-2">
          <div className="flex items-center gap-2 p-2 rounded-lg bg-muted/50">
            <MessageCircle className="w-4 h-4 text-primary" />
            <span className="text-xs text-muted-foreground">Group chat</span>
          </div>
          <div className="flex items-center gap-2 p-2 rounded-lg bg-muted/50">
            <Calendar className="w-4 h-4 text-primary" />
            <span className="text-xs text-muted-foreground">Plan meetups</span>
          </div>
        </div>
        
        {/* Sparkle effect */}
        <div className="flex items-center justify-center gap-2 text-primary text-sm">
          <Sparkles className="w-4 h-4" />
          <span>Find your wellness tribe</span>
        </div>
      </div>
    </Card>
  );
};
